/**
 * The standalone Iron Peak upload link.
 *
 * Josh, 2026-08-31: "duplicate to another separate link so one can remain in
 * the hub and the other can go to members for immediate use." Iron Peak members
 * have no hub accounts yet, and waiting for them to be created would leave the
 * desktop spreadsheet in place for weeks.
 *
 * ⚠️ IT CHECKS THE TOKEN BEFORE RENDERING ANYTHING. A dead link must look dead
 * immediately, not after somebody has typed twelve fields and dropped a dec
 * page. When the hub opens and POLICY_UPLOAD_LINK_TOKEN is cleared, every copy
 * of this URL — forwarded, bookmarked, pasted into a group chat — lands on the
 * closed message rather than a form that will fail on submit.
 *
 * ⚠️ NO SHELL, NO RAIL, NO ROUTE OUT. Somebody arriving here is not a hub user
 * and may never become one; showing them navigation to pages they cannot open
 * would be an advertisement for a locked door.
 */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { POLICY_UPLOAD_CONTACT, PolicyUpload } from './PolicyUpload';

export function PolicyUploadLink() {
  const { token } = useParams<{ token: string }>();
  const [live, setLive] = useState<boolean | null>(null);

  useEffect(() => {
    if (!token) {
      setLive(false);
      return;
    }
    api
      .policyUploadLinkLive(token)
      .then(() => setLive(true))
      .catch(() => setLive(false));
  }, [token]);

  if (live === null) {
    return (
      <div className="wrap">
        <p className="supp-note">Loading…</p>
      </div>
    );
  }

  if (!live) {
    return (
      <div className="wrap">
        <div className="page-head">
          <div>
            <div className="page-title">This link is no longer active</div>
            <div className="page-sub">
              Policy uploads have moved into the Commercial Hub. Email{' '}
              <a href={`mailto:${POLICY_UPLOAD_CONTACT}`}>{POLICY_UPLOAD_CONTACT}</a> and they will
              get you set up — or send the policy to that address in the meantime, and nothing is
              lost.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <PolicyUpload linkToken={token} />;
}
